
/**
 * Module dependencies.
 */

import { CurrencyOptions, formatCurrency as defaultFormatCurrency } from 'slyk-web-libs/assets';
import { satCode, satSymbol } from 'client/core/constants/assets';
import { upperCase } from 'lodash';
import BigNumber from 'bignumber.js';

/**
 * Sat rate.
 */

const satRate = 100000000;

/**
 * Export `formatCurrency` util.
 */

export function formatCurrency(value: number | string | BigNumber, options: CurrencyOptions) {
  const { assetCode } = options;
  const amount = value instanceof BigNumber ? value : new BigNumber(value);

  if (assetCode !== 'btc' || amount.isEqualTo(0) || amount.abs().isGreaterThanOrEqualTo(0.1)) {
    return defaultFormatCurrency(value, options);
  }

  return defaultFormatCurrency(amount.multipliedBy(satRate).toFixed(), {
    ...options,
    assetCode: satCode
  }).replace(upperCase(satCode), satSymbol);
}
